import React from 'react';
import HeroCarousel from '../components/Home/HeroCarousel';
import AboutSection from '../components/Home/AboutSection';
import CounterFacts from '../components/Home/CounterFacts';
import ServicesSection from '../components/Home/ServicesSection';
import TestimonialSection from '../components/Home/TestimonialSection';
import TeamSection from '../components/Home/TeamSection';
import SearchModal from '../components/Home/SearchModal';

const Home = () => {
  return (
    <>
      <HeroCarousel />
      <SearchModal />
      <AboutSection />
      <CounterFacts />
      <ServicesSection />
      <TestimonialSection />
      {/* <TeamSection /> */}
    </>
  );
};

export default Home; 